import { isFeatureEnabled } from 'owa-feature-flags';

// Check if Proactive Drafts feature is enabled
export function isProactiveDraftEnabled(): boolean {
    return (
        isFeatureEnabled('mon-copilot-proactive-drafts') ||
        isFeatureEnabled('mon-copilot-proactive-drafts-enableForAllEmails')
    );
}
